import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { View } from "react-native";
import ParentHome from "@/elements/components/home/parent-home";
import StudentHome from "@/elements/components/home/student-home";
import TutorHome from "@/elements/components/home/tutor-home";
import Loader from "@/elements/components/shared/loader";
import { api } from "@/elements/components/utils/convex-api";

function HomeScreen() {
  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {}),
  );
  const persona = currentUser?.persona;

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      {persona === "parent" ? (
        <ParentHome />
      ) : persona === "tutor" ? (
        <TutorHome />
      ) : (
        <StudentHome />
      )}
    </View>
  );
}

export default HomeScreen;
